import React from 'react';

/* Ручка перетаскивания (три линии). Тащить можно только зажав её.
   Принимает handleProps из useDragSort. Курсор обычный (без «хваталки»). */
export default function DragHandle(props) {
  return (
    <button type="button" className="drag-handle" title="Перетащить" aria-label="Перетащить" {...props}>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="4" y1="7" x2="20" y2="7" />
        <line x1="4" y1="12" x2="20" y2="12" />
        <line x1="4" y1="17" x2="20" y2="17" />
      </svg>
    </button>
  );
}
